import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useSetSelectTheme } from "@/contexts/SelectThemeContext";
import StripePayment from "@/components/payment/StripePayment";
import ManualPayment from "@/components/payment/ManualPayment";

export default function PaymentInstructions() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const o = await api.get(`/orders/${orderId}`);
        setOrder(o.data);
      } catch (err) {
        setError(err.response?.data?.detail || "We couldn't find that order.");
      }
    })();
  }, [orderId]);

  // iter138.1 — theme flip must match Cart + Checkout. Setting via
  // useSetSelectTheme cleans up on unmount so leaving /payment restores BBK.
  const isSelect = order?.cart_tier === "select";
  useSetSelectTheme(isSelect);

  if (error) {
    return (
      <div className={isSelect ? "bg-[#F1E5C7] min-h-screen" : ""}>
        <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="payment-page-error">
          <p className={`overline mb-3 ${isSelect ? "text-[#6E521A]" : "text-oxblood"}`}>Order not found</p>
          <h1 className={`font-serif text-4xl md:text-5xl tracking-tight mb-4 ${isSelect ? "text-[#1B1614]" : ""}`}>Something's off.</h1>
          <p className={`mb-8 ${isSelect ? "text-[#1B1614]/70" : "text-stone"}`}>{error}</p>
          <Link
            to="/orders"
            className={`inline-block px-6 py-3 tracking-[0.22em] text-xs uppercase rounded-full transition-colors ${
              isSelect
                ? "bg-[#DDA94E] text-[#1B1614] hover:bg-[#F1E5C7]"
                : "bg-charcoal text-bone hover:bg-oxblood"
            }`}
            data-testid="payment-error-view-orders-btn"
          >
            View my orders
          </Link>
        </div>
      </div>
    );
  }

  if (!order) return (
    <div className={isSelect ? "bg-[#F1E5C7] min-h-screen" : ""}>
      <div className={`p-12 overline ${isSelect ? "text-[#1B1614]/70" : ""}`}>Loading order…</div>
    </div>
  );

  if (order.payment_method === "stripe") return <StripePayment order={order} />;
  return <ManualPayment order={order} />;
}
